exports = module.exports = require("../../../../../../develop/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body{text-align:center;width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /Users/gtirby/develop/~/css-loader?minimize!/Users/gtirby/develop/~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-eacd8cfc","scoped":false,"hasInlineConfig":false}!/Users/gtirby/develop/~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/OrderList.vue
// module id = 372
// module chunks = 0